import { Customer, InventoryMovement, Order, Product, Supplier } from "@/lib/types";

export const seedProducts: Product[] = [
    {
        id: "p1",
        name: "Sofia Floral Midi Dress",
        sku: "DRS-SOFIA",
        category: "Dress",
        sourceOrigin: "Bangkok",
        status: "active",
        material: "Cotton Blend",
        description: "Soft floral midi dress ideal for casual dates and brunch looks.",
        coverImage: "https://images.unsplash.com/photo-1515886657613-9f3515b0c78f?q=80&w=1200&auto=format&fit=crop",
        createdAt: new Date().toISOString(),
        variants: [
            { id: "v1", sku: "DRS-SOFIA-PNK-S", color: "Pink", size: "S", stock: 12, reserved: 2, salePrice: 899, costPrice: 420 },
            { id: "v2", sku: "DRS-SOFIA-PNK-M", color: "Pink", size: "M", stock: 8, reserved: 1, salePrice: 899, costPrice: 420 },
            { id: "v3", sku: "DRS-SOFIA-WHT-S", color: "White", size: "S", stock: 6, reserved: 0, salePrice: 899, costPrice: 420 }
        ]
    },
    {
        id: "p2",
        name: "Mila Ribbon Mini Dress",
        sku: "DRS-MILA",
        category: "Dress",
        sourceOrigin: "Hong Kong",
        status: "active",
        material: "Linen",
        description: "Minimal ribbon mini dress with a flattering silhouette.",
        coverImage: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?q=80&w=1200&auto=format&fit=crop",
        createdAt: new Date().toISOString(),
        variants: [
            { id: "v4", sku: "DRS-MILA-BGE-S", color: "Beige", size: "S", stock: 10, reserved: 1, salePrice: 999, costPrice: 470 },
            { id: "v5", sku: "DRS-MILA-BGE-M", color: "Beige", size: "M", stock: 7, reserved: 0, salePrice: 999, costPrice: 470 }
        ]
    }
];

export const seedCustomers: Customer[] = [
    { id: "c1", name: "Angela Cruz", mobile: "09171234567", address: "Makati City", totalOrders: 4, totalSpend: 3596 },
    { id: "c2", name: "Bea Lim", mobile: "09981234567", address: "Quezon City", totalOrders: 2, totalSpend: 1998 }
];

export const seedSuppliers: Supplier[] = [
    { id: "s1", name: "Bangkok Style Hub", contactPerson: "Nina", mobile: "+66 812345678", city: "Bangkok", origin: "Bangkok" },
    { id: "s2", name: "HK Trend Apparel", contactPerson: "Mika", mobile: "+852 61234567", city: "Hong Kong", origin: "Hong Kong" }
];

export const seedOrders: Order[] = [
    {
        id: "o1",
        orderNumber: "ORD-1001",
        customerName: "Angela Cruz",
        channel: "Instagram",
        paymentStatus: "paid",
        fulfillmentStatus: "packed",
        totalAmount: 1798,
        createdAt: new Date().toISOString(),
        items: [
            { id: "oi1", productName: "Sofia Floral Midi Dress", variantSku: "DRS-SOFIA-PNK-S", qty: 2, unitPrice: 899 }
        ]
    },
    {
        id: "o2",
        orderNumber: "ORD-1002",
        customerName: "Bea Lim",
        channel: "TikTok",
        paymentStatus: "pending",
        fulfillmentStatus: "pending",
        totalAmount: 999,
        createdAt: new Date().toISOString(),
        items: [
            { id: "oi2", productName: "Mila Ribbon Mini Dress", variantSku: "DRS-MILA-BGE-S", qty: 1, unitPrice: 999 }
        ]
    }
];

export const seedInventoryMovements: InventoryMovement[] = [
    { id: "m1", variantSku: "DRS-SOFIA-PNK-S", type: "stock_in", qty: 20, notes: "Initial stock", createdAt: new Date().toISOString() },
    { id: "m2", variantSku: "DRS-SOFIA-PNK-S", type: "sale", qty: -2, notes: "Instagram order ORD-1001", createdAt: new Date().toISOString() },
    { id: "m3", variantSku: "DRS-MILA-BGE-S", type: "stock_in", qty: 15, notes: "Initial stock", createdAt: new Date().toISOString() }
];